<div fxLayout="row wrap" class="header-container">
  <ix-breadcrumb fxFlex="100%"></ix-breadcrumb>
  <div class="title-container">
    <h1>{{ currentTitle$ | async | translate }}</h1>
    <div class="actions-container">
      <ng-content></ng-content>
    </div>
  </div>
</div>
